import React from 'react';

export class EmptyEvents extends React.PureComponent {
  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { addEvent, day, status } = this.props;
    return (
      <div className='no-events'>
        No events yet{' '}
        <button
          type='button'
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          // eslint-disable-next-line react/no-unknown-property
          day={day}
          disabled={status}
          className=' btn btn-def no-event-ref'
          onClick={addEvent}
        >
          + Add Event
        </button>
      </div>
    );
  }
}
